import ClickTracker from '@/components/Common/ClickTracker';
import RectButton from '@/components/Common/DesignSystem/RectButton/RectButton';
import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { Braze } from '@/services/TrackerService';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useContext } from 'react';

import styles from './index.module.scss';

const CallToAction: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  const onClick = useCallback(() => {
    Braze.sendCustomEvent('click_nolcard_issue_btn');
    void store.moveToHyunDaiCard();
  }, []);

  return (
    <ImpressionDivWrapper
      logData={{
        pageName: store.pageName,
        object: 'newJoinBtn',
        motherPageVersion: store.version,
        motherPageSectionType: '',
        motherPageSectionName: '',
        motherPageSectionNameSubTitle: '바로 혜택 보기',
      }}
    >
      <div className={clsx(styles.container)}>
        <ClickTracker
          pageName={store.pageName}
          logData={{
            object: 'newJoinBtn',
            objectType: 'Btn',
            objectContainer: '',
            motherPageVersion: store.version,
            motherPageSectionType: '',
            motherPageSectionName: '',
            motherPageSectionNameSubTitle: '바로 혜택 받기',
            deepLinkUri: '',
          }}
        >
          <RectButton.Primary className={styles.buttons} as={'button'} onClick={onClick}>
            NOL 카드 자세히 보기
          </RectButton.Primary>
        </ClickTracker>
      </div>
    </ImpressionDivWrapper>
  );
};

export default observer(CallToAction);
